import { render, staticRenderFns } from "./Misc.vue?vue&type=template&id=65d5209b&scoped=true&lang=html"
import script from "./Misc.vue?vue&type=script&lang=js"
export * from "./Misc.vue?vue&type=script&lang=js"
import style0 from "./Misc.vue?vue&type=style&index=0&id=65d5209b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5209b",
  null
  
)

export default component.exports